import { SurveyUserPageFilterReqDTO } from '@/api/DTO/survey/survey.interface';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function SurveyUserPageSummaryFilterSection({
	children,
}: React.PropsWithChildren) {
	const { t } = useTranslation();
	const { control } = useFormContext<SurveyUserPageFilterReqDTO>();

	return (
		<Grid container rowSpacing={2} columnSpacing={1} marginBottom='20px'>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='loginID'
					control={control}
					placeholder={t('common.pleaseEnterKeywordSearch')}
				/>
			</Grid>
		</Grid>
	);
}
